import TomSelect from 'tom-select';
import { TomInput } from 'tom-select/dist/types/types';

export function select(selector = '.select', _settings = {}) {
  document.querySelectorAll(selector).forEach((element) => {
    const selectElement = element.querySelector<TomInput>('.select__select');
    if (!selectElement) return;

    new TomSelect(selectElement, {
      controlInput: '',
      copyClassesToDropdown: false,
      wrapperClass: 'select__wrapper',
      controlClass: 'select__control',
      dropdownClass: 'select__dropdown',
      dropdownContentClass: 'select__dropdown-content',
      itemClass: 'select__item',
      optionClass: 'select__option',
    });
  });
}
